import { Action, createReducer, on } from '@ngrx/store';
import { ReplacementThresholdListResponse, SetThresholdResponse, ThresholdsResponse } from '../../../api/models';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { thresholdActions } from './threshold.action';

export interface ThresholdState {
  loadAll: {
    state: ILoaderActionPayload;
    data?: ThresholdsResponse;
  };
  loadThreshold: {
    state: ILoaderActionPayload;
    data?: ReplacementThresholdListResponse;
  };
  setTraking: {
    state: ILoaderActionPayload;
    data?: SetThresholdResponse;
  };
  deleteThreshold: {
    state: ILoaderActionPayload;
  };
}

const initialState: ThresholdState = {
  loadAll: { state: { value: LoadingState.NONE } },
  loadThreshold: { state: { value: LoadingState.NONE } },
  setTraking: { state: { value: LoadingState.NONE } },
  deleteThreshold: { state: { value: LoadingState.NONE } },
};

const reducer = createReducer(
  initialState,
  on(thresholdActions.loadAll, (state) => ({
    ...state,
    loadAll: { state: { value: LoadingState.LOADING } },
  })),
  on(thresholdActions.loadAllDone, (state, props) => ({
    ...state,
    loadAll: { state: props.state, data: props.data },
  })),
  on(thresholdActions.loadThreshold, (state) => ({
    ...state,
    loadThreshold: { state: { value: LoadingState.LOADING } },
  })),
  on(thresholdActions.loadThresholdDone, (state, props) => ({
    ...state,
    loadThreshold: { state: props.state, data: props.data },
  })),
  on(thresholdActions.setTraking, (state) => ({
    ...state,
    setTraking: { state: { value: LoadingState.LOADING } },
  })),
  on(thresholdActions.setTrakingDone, (state, props) => ({
    ...state,
    setTraking: { state: props.state, data: props.data },
  })),
  on(thresholdActions.setTrakingSetState, (state, props) => ({
    ...state,
    setTraking: { state: props.state },
  })),
  on(thresholdActions.deleteThreshold, (state) => ({
    ...state,
    deleteThreshold: { state: { value: LoadingState.LOADING } },
  })),
  on(thresholdActions.deleteThresholdDone, (state, props) => ({
    ...state,
    deleteThreshold: { state: props.state },
  })),
);

export function thresholdReducer(state: ThresholdState | undefined, action: Action) {
  return reducer(state, action);
}
